// * React and Redux:
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { setTexts } from "../features/TextsSlice";

// * Material UI components:
import { 
    Stack,
    CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";

// * Handlers:
import getTexts from '../handlers/fetchTexts';

// * Axios:
import axios from "axios";


const VerifyView = () => {

    const texts = useSelector((state) => state.texts.texts);
    const language = localStorage.getItem("language");
    const dispatch = useDispatch();

    const {id, code} = useParams();
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const currentLanguage = localStorage.getItem("language") || "pl";
        console.log("Current language: ", currentLanguage);
        getTexts(dispatch, setTexts, currentLanguage);
    }, [dispatch]);

    useEffect(() => {

        console.log(texts["message_request_success"]);

        const url = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_REQUESTS_VERIFY;

        axios.post(url, {
            id: id,
            verif_code: code,  
        },
        {
            headers: {
                'Accept-Language': localStorage.getItem("language") || "pl"
            }
        }
        ).then((_) => {
            setStatus(1);
            setMessage(
                texts["message_request_success"]
            );
        }).catch((error) => {
            setStatus(-1);
            console.error("Error while verifying request: ", error);
            setMessage(
                texts["message_request_failure"]
            );
        }).finally(() => {
            setLoading(false);
        });
    }, [id, code, texts, language]);

    return (
        <div className="status-message">
            {
                loading ? (
                    <CircularProgress color="success" />
                ) : status < 0 ? (
                    <Stack spacing={2}>
                        <ErrorIcon color="error" style={{ fontSize: "63px" }} />
                        <h1>{texts["message_request_failure"]}</h1>
                    </Stack>
                ) : status > 0 ? (
                    <Stack spacing={2}>
                        <CheckIcon color="success" style={{ fontSize: "63px" }} />
                        <h1>{texts["message_request_success"]}</h1>
                    </Stack>
                ) : null
            }
            <h1>{message}</h1>
        </div>
    );
};

export default VerifyView;
